module.exports = __webpack_public_path__ + "img/user.c0e29ce8.png";